import { Tooltip, Typography } from "@mui/material";

import { CurrencyCodes } from "Infrastructure/Api/Api";
import { formatPriceWithConversion } from "Infrastructure/Utils/CurrencyUtils";
import { useCurrency } from "Intl/Hooks/useCurrency";

interface PriceProps {
  amount: number | null | undefined;
  decimalPlaces?: number;
  component?: "span" | "div";
}

export const Price = ({
  amount,
  decimalPlaces = 2,
  component = "span",
}: PriceProps): React.ReactNode => {
  const { userCurrency, getRate } = useCurrency();

  const rateData = getRate(userCurrency);
  const { primary, secondary, tooltipText } = formatPriceWithConversion(
    amount,
    userCurrency,
    rateData?.rate,
    rateData?.rateDate,
    decimalPlaces,
  );

  if (!secondary || userCurrency === CurrencyCodes.EUR) {
    return (
      <Typography component={component} variant="inherit">
        {primary}
      </Typography>
    );
  }

  return (
    <Tooltip title={tooltipText ?? ""} arrow placement="top">
      <Typography
        component={component}
        variant="inherit"
        sx={{
          cursor: "help",
          borderBottom: "1px dotted",
          borderColor: "text.disabled",
        }}
      >
        {primary} ({secondary})
      </Typography>
    </Tooltip>
  );
};
